/**
 * Redirect-based payment methods (MobilePay, iDEAL, Bancontact, Klarna…) leave
 * the page and come back to Stripe's `return_url` with `payment_intent`,
 * `payment_intent_client_secret` and `redirect_status` appended. Until now the
 * order id only survived that round trip in localStorage, which is empty when
 * the bank app hands the fan back to a different browser (in-app webview →
 * Safari). Carry it in the URL too.
 */
const STRIPE_PARAMS = ['payment_intent', 'payment_intent_client_secret', 'redirect_status'];
const OUR_PARAMS = ['order', 'preorder'];

export function buildStripeReturnUrl(href: string, opts: { orderId: string; preorder?: boolean }): string {
  const url = new URL(href);
  url.searchParams.set('order', opts.orderId);
  if (opts.preorder) url.searchParams.set('preorder', '1');
  else url.searchParams.delete('preorder');
  return url.toString();
}

export interface StripeReturn {
  redirectStatus: string | null;
  orderId: string | null;
  preorder: boolean;
}

export function parseStripeReturn(search: string): StripeReturn {
  const params = new URLSearchParams(search);
  return {
    redirectStatus: params.get('redirect_status'),
    orderId: params.get('order'),
    preorder: params.get('preorder') === '1',
  };
}

/** The URL without Stripe's return params or ours; other params and the hash stay. */
export function stripStripeReturnParams(href: string): string {
  const url = new URL(href);
  for (const p of [...STRIPE_PARAMS, ...OUR_PARAMS]) url.searchParams.delete(p);
  const query = url.searchParams.toString();
  return `${url.origin}${url.pathname}${query ? `?${query}` : ''}${url.hash}`;
}
